import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
} from "@mui/material";
import {
  AccountCircle,
  HomeWork,
  MiscellaneousServicesOutlined,
  Notifications,
} from "@mui/icons-material";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import { logout } from "../actions/authActions";

const items = [
  { text: "Proyectos", icon: <HomeWork />, path: "/dashboard/proyectos" },
  // {
  //   text: "Inversiones",
  //   icon: <Diversity3Icon />,
  //   path: "/dashboard/inversionistas",
  // },
  {
    text: "Inversionistas",
    icon: <AccountCircle />,
    path: "/dashboard/asociados",
  },
  {
    text: "Participación",
    icon: <Diversity3Icon />,
    path: "/dashboard/participacion",
  },
  {
    text: "Servicios",
    icon: <MiscellaneousServicesOutlined />,
    path: "/dashboard/servicios",
  },
  {
    text: "Notificaciones",
    icon: <Notifications />,
    path: "/dashboard/notificaciones",
  },
];

const styles = {
  drawer: {
    width: 300,
    flex: 1,
  },
  logoWrapper: {
    justifyContent: "center",
  },
  logo: {
    width: "60%",
    cursor: "pointer",
  },
  dividerWrapper: {
    marginY: "0.75rem",
    paddingX: "1rem",
  },
  buttonWrapper: {
    textAlign: "center",
    padding: "1rem",
  },
};

const AppDrawer = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigate = (path) => () => {
    navigate(path);
    props.onClose();
  };

  const handleLogout = () => {
    dispatch(logout({ callback: () => navigate("/login") }));
  };

  return (
    <Drawer {...props}>
      <Box sx={styles.drawer} role="presentation">
        <List>
          <ListItem sx={styles.logoWrapper}>
            <img
              src="/img/IDE.png"
              alt="IDE logo"
              style={styles.logo}
              onClick={handleNavigate("")}
            />
          </ListItem>
          <Box sx={styles.dividerWrapper}>
            <Divider />
          </Box>
          {items.map((item) => (
            <ListItemButton key={item.text} onClick={handleNavigate(item.path)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
        </List>
      </Box>
      <Box sx={styles.buttonWrapper}>
        <Button fullWidth variant="text" onClick={handleLogout}>
          Cerrar sesión
        </Button>
      </Box>
    </Drawer>
  );
};

export default AppDrawer;
